import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { AuthGuard } from '../../auth/auth.guard';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'vr-toolbar-enterprise-button',
  templateUrl: './toolbar-enterprise-button.component.html',
  styleUrls: ['./toolbar-enterprise-button.component.scss']
})
export class ToolbarEnterpriseButtonComponent implements OnInit, AfterViewInit {

  user;
  enterprises;
  selectedEnterprise;
  isOpen: boolean;
  isGuest: boolean;

  constructor(
    private router: Router,
    private authGuard: AuthGuard,
    private authService: AuthService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.isGuest = this.authGuard.rights && this.authGuard.rights.role === 'GUEST';
    this.user = this.authGuard.session;
    this.enterprises = this.authGuard.enterprises;
    for (let i = 0; i < this.enterprises.length; i++) {
      if (this.enterprises[i]['id'] === this.authGuard.session['selected_enterprise']) {
        this.selectedEnterprise = this.enterprises[i];
      }
    }
  }

  ngAfterViewInit() {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  changeDefaultEnterprise(id) {
    this.http.post(environment.API_PATH + 'auth/enterprise', {enterprise_id: id}, {withCredentials: true}).subscribe(() => {
      this.isOpen = false;
      location.href = '/';
    });
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/toolbar/toolbar-enterprise-button/toolbar-enterprise-button.component.ts